// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3dha8","tab":"Tabs_tab__3KvxN","tabActive":"Tabs_tabActive__3P9gx"};